import { all, put, take } from 'redux-saga/effects';

import { PIPELINE__SETTINGS } from 'PipeRouter';
import initialize from './initialize';
import mobile from './mobile';


function* pipeline() {
  while (true) {
    const { data:{ cmd, data}} = yield take(PIPELINE__SETTINGS);

    yield put({ type: cmd, data });
  }
}


export default function* settings() {
  yield all([
    pipeline(),
    initialize(),
    mobile()
  ]);
}
